module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAYAAAARZmTlAAAAjElEQVQ4ja3U0QmAMAwE0FOkOziNDuFGdiRHcAz/3UGFk2IFP1RymoNQGkgf/UlBEmJqALMyUopAB2DKpz3pJ8bqSK48suS7aVYBlgyMKqQCMfeiAn0BoEJfAQn6A5ihv4AJ8gDO6p8gL+AV8gQeodRsHYE7qEmNQHJwBK5QejecW7gCsKnr2JAKwLYDT1jJJi0b4zUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/suspension/jt.png
// module id = Rv22
// module chunks = 6